import React, { useState, useEffect } from "react";

import "bootstrap/dist/css/bootstrap.min.css";



// Accountant Form Component

const AccountantForm = ({ formData, onChange }) => {

  return (

    <div className="mt-3">

      <div className="mb-3">

        <label className="form-label">Accounting Firm:</label>

        <input

          type="text"

          className="form-control"

          name="accountingFirm"

          value={formData.accountingFirm}

          onChange={onChange}

          required

        />

      </div>



      <div className="mb-3">

        <label className="form-label">Accountant's Name:</label>

        <input

          type="text"

          className="form-control"

          name="accountantName"

          value={formData.accountantName}

          onChange={onChange}

          required

        />

      </div>



      <div className="mb-3">

        <label className="form-label">Accountant's Direct Email:</label>

        <input

          type="email"

          className="form-control"

          name="accountantEmail"

          value={formData.accountantEmail}

          onChange={onChange}

          required

        />

      </div>

    </div>

  );

};



// Organization Email Form Component

const OrganizationEmailForm = ({ formData, onChange }) => {

  return (

    <div className="mt-3">
  <h3>Invite Your Client</h3> {/* Added Title */}

  <div className="mb-3">
    <label className="form-label">Your Client Email:</label>
    <input
      type="email"
      className="form-control"
      name="organizationEmail"
      value={formData.organizationEmail}
      onChange={onChange}
      required
    />
  </div>

  <div className="mb-3">
    <label className="form-label">Your Client Name:</label>
    <input
      type="text" 
      className="form-control"
      name="organizationName" 
      value={formData.organizationName} 
      onChange={onChange}
      required
    />
  </div>
</div>


  );

};



// Main Step3 Component

const Step3 = () => {

  const [formData, setFormData] = useState({

    accountingFirm: "",

    accountantName: "",

    accountantEmail: "",

    organizationEmail: "",

  });

  const [role, setRole] = useState(localStorage.getItem("role"));

  const [businessOwner, setBusinessOwner] = useState(null);



  useEffect(() => {

    // Optionally handle changes in role in localStorage

    const roleFromStorage = localStorage.getItem("role");

    setRole(roleFromStorage);

  }, []);



  const handleBusinessOwnerChange = (option) => {

    setBusinessOwner(option);

  };



  const handleInputChange = (e) => {

    setFormData({ ...formData, [e.target.name]: e.target.value });

  };



  const isFormComplete =

    formData.accountingFirm.trim() &&

    formData.accountantName.trim() &&

    formData.accountantEmail.trim();



  const isBusinessFormComplete =

    businessOwner === "Yes" ? formData.organizationEmail.trim() : true;



  return (

    <div className="d-flex justify-content-center align-items-center">

      <div

        className="p-4 bg-white rounded shadow"

        style={{ width: "500px", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)" }}

      >

        {role === "Business Owner" ? (

          <>

            <AccountantForm formData={formData} onChange={handleInputChange} />

            <p className="mt-3 text-success">

              We'll fire off an invite to get your accountant on board with BVO Ai.

            </p>

            <button className="btn btn-primary w-100 mt-3" disabled={!isFormComplete}>

              Invite Accountant

            </button>

          </>

        ) : role === "Accountant" ? (

          <>

            <OrganizationEmailForm formData={formData} onChange={handleInputChange} />

            <button className="btn btn-primary w-100 mt-3" disabled={!isBusinessFormComplete}>

              Invite

            </button>

          </>

        ) : (

          <p className="text-center">Please set a valid role in localStorage to continue.</p>

        )}

      </div>

    </div>

  );

};



export default Step3;

